import { LIMITS, normalizeEventName, sanitizeUrl } from '@l3ns/shared/constants';
import { ulid } from '@l3ns/shared/ulid';
import type { EventProps, PropValue } from '@l3ns/shared/types';
import { doc, evH, now } from '../auto/util';
import { dlog } from './safe';
import { ensureSession } from './session';
import { st } from './state';
import { flush } from './transport';

function cleanProps(props?: Record<string, unknown>): EventProps | undefined {
	if (!props || typeof props != 'object') return;
	const out: EventProps = {};
	let n = 0;
	for (const k in props) {
		if (n >= LIMITS.MAX_PROP_KEYS) break;
		let v = props[k] as PropValue;
		const t = typeof v;
		if (t == 'string') v = (v as string).slice(0, LIMITS.MAX_PROP_VALUE_LEN);
		else if (v !== null && t != 'boolean' && !(t == 'number' && isFinite(v as number))) continue; // objects/functions/symbols never leave the page
		out[k.slice(0, LIMITS.MAX_PROP_KEY_LEN)] = v;
		n++;
	}
	return n ? out : undefined;
}

/**
 * Queue an event. `session_started`/`user_returned` are emitted here when the
 * session rotates, so every queued event belongs to a live session.
 */
export function enqueue(name: string, props?: Record<string, unknown>): void {
	if (!st.consent_) return;
	const n = normalizeEventName(String(name));
	if (!n) return;
	if (st.inited_) {
		const s = ensureSession();
		if (s.startedNew && st.auto_.sessions && n != 'session_started' && n != 'user_returned') {
			push('session_started');
			if (s.isReturning) push('user_returned');
		}
	}
	push(n, cleanProps(props));
}

function push(name: string, props?: EventProps): void {
	st.q_.push({
		id: ulid(),
		name,
		ts: now(),
		url: sanitizeUrl(location.href),
		title: doc.title.slice(0, LIMITS.MAX_STR_LEN) || undefined,
		props,
	});
	dlog('queued', name, props);
	for (const f of evH) f(name);
	if (st.q_.length > 200) {
		st.q_.shift();
		st.diag_.dropped++;
	}
	if (st.q_.length >= 20) flush('size');
}
